import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "hidden sm:block" }
const _hoisted_3 = { class: "flex flex-col gap-4" }
const _hoisted_4 = { class: "flex items-start gap-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col gap-2 pl-11" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "bg-primary mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-white"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "whitespace-pre-line" }
const _hoisted_11 = { class: "mt-1 text-[11px] text-gray-500" }
const _hoisted_12 = { class: "bg-primary max-w-[80%] rounded-bl-xl rounded-br-xl rounded-tl-xl px-4 py-3 text-sm text-white" }
const _hoisted_13 = { class: "whitespace-pre-line" }
const _hoisted_14 = { class: "mt-1 text-right text-[11px] text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: $setup.auraPanelOpened,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.auraPanelOpened) = $event)),
    title: _ctx.$t('contact.aura.title'),
    icon: $setup.SparklesIcon
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.auraPanelOpened = true)),
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: $setup.AuraConversationIcon,
            class: "mr-0 h-5 w-5 sm:mr-3"
          }, null, 8 /* PROPS */, _hoisted_1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('contact.aura.askAura')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        ($setup.messages.length === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createCommentVNode(" Aura initial message "),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: $setup.AuraConversationIcon,
                  class: "h-8 w-8 shrink-0",
                  alt: "AURA"
                }, null, 8 /* PROPS */, _hoisted_5),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "rounded-2x1 max-w-[85%] rounded-tl-sm bg-white px-4 py-3 text-sm leading-relaxed shadow-sm" }, " Pergunte ao Aura sobre este contexto. Ele responde com base nas ligações registradas. ", -1 /* CACHED */))
              ]),
              _createCommentVNode(" Default questions "),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.auraChatMocks, (chat) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: chat.question,
                    type: "button",
                    class: "hover:border-primary rounded-lg border bg-white px-3 py-2 text-left text-sm transition-colors hover:bg-gray-100",
                    onClick: ($event: any) => ($setup.askAura(chat))
                  }, _toDisplayString(chat.question), 9 /* TEXT, PROPS */, _hoisted_7))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Messages "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["flex items-start gap-3", { 'justify-end': message.role === 'user' }])
          }, [
            (message.role === 'aura')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (message.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode($setup["RefreshIcon"], {
                          class: "h-4 w-4 animate-spin",
                          style: {"animation-duration":"1.5s","animation-direction":"reverse"}
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: $setup.AuraConversationIcon,
                        class: "h-8 w-8",
                        alt: "AURA"
                      }, null, 8 /* PROPS */, _hoisted_9)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["max-w-[85%] rounded-bl-xl rounded-br-xl rounded-tr-xl bg-white px-4 py-2.5 text-sm leading-relaxed shadow", message.loading ? 'text-gray-500' : ''])
                  }, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(message.content), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(message.time), 1 /* TEXT */)
                  ], 2 /* CLASS */)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(message.content), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(message.time), 1 /* TEXT */)
                  ]),
                  _createVNode($setup["UserIcon"], { class: "text-primary h-6 w-6 shrink-0" })
                ], 64 /* STABLE_FRAGMENT */))
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title", "icon"]))
}